import { useNavigate } from "react-router";
import { Screen, usePodContext } from "../PodContext";
import Feeling from "./Feeling";
import Footer from "./Footer";
import GoHomeTimer from "./GoHomeTimer";
import Header from "./Header";
import "./PreFeeling.css";

const PreFeeling = () => {
  const { setPreFeeling } = usePodContext();
  const navigate = useNavigate();

  const selected = (choice: number) => {
    setPreFeeling(choice);
    navigate(Screen.SELECT_SCENE);
  };

  return (
    <div className="image-bg-container">
      <GoHomeTimer />
      <Header totalSteps={4} title="Mood check-in" progress={2} />
      <div className="vr-pre-feeling-container">
        <Feeling selected={selected} />
      </div>
      <Footer />
    </div>
  );
};

export default PreFeeling;
